import React from "react";
import { Translate } from "../../utils/Translate";
import Button from "@material-ui/core/Button";
import { Grid, Typography } from "@material-ui/core";
import CloseMobile from "../../CommonImages/closeMobile";
import Close from "../../CommonImages/close";
import { getMediaScreenResolution } from "../../utils/utilityfunctions";
import config from "../../assets/config.json"

export function StripComponent(props) {
  return (
    <div
      onLoad={props.showleaveBarMethod}
      onMouseEnter={props.showleaveBarMethod}
      className="video-paused-infobox-leave vjs-has-started vjs-control-bar"
      style={{
        height: "4rem !important",
        position: "absolute",
        top: "0px",
        marginTop: "0px",
        alignItems: "baseline", backgroundColor: "transparent !important"
      }}
    >
      {props.isFullScreen &&
        <Typography variant="h2" className="videoOverlayText p-r-s-72" style={{ marginTop: "-20px" }}>{props.videotitle}</Typography>

      }
     {getMediaScreenResolution()?
      <Close
        onClick={props.leavingClassSelected}
        color={config.primaryColor}
        cls="closeButtonbig customClosePlayer  modalClose  btn-default makeTextClickable"
        style={{ boxSizing: "content-box", right: "16px" }}
      />:
      <CloseMobile
        cls="closeButtonMobile customClosePlayer modalClose makeTextClickable"
        color={config.primaryColor}            
        onClick={props.leavingClassSelected}
      />
     }
    </div>
  );
}
export function ModalOverVideo(props) {
  return (
    <div className={props.class ? "liveStram-video-paused-infobox" : "video-paused-infobox"}>
      {props.doNotShowCloseButton ?
        null :(getMediaScreenResolution()? 
          <Close
            color={config.primaryColor}
            cls="closeButtonbig customClosePlayer modalClose btn-default makeTextClickable"
            onClick={props.resumeHandler}
          /> :
          <CloseMobile 
          cls="closeButtonMobile customClosePlayer modalClose makeTextClickable"
          color={config.primaryColor}           
          onClick={props.resumeHandler}
          />
        )
      }

      <Grid container className={props.class ? "newStrip liveStreamQuitModal" : "newStrip"} direction="column">
        <Grid item>
          <Button
            disabled
            // variant="contained"
            color="secondary"
            className="LeaveConfirmationTextButton"
            style={{
              backgroundColor: "transparent",
              width: "100%"
            }}
            onClick={props.resumeHandler}
          >
            <p className='leaveConfirmation'>
              {Translate({ id: "Player.LeaveConfirmation" })}
            </p>

          </Button>
        </Grid>

        <Grid item className="padding16">
          {props.elapsedTime <= 60 && (
            <Button
              variant="contained"
              color="secondary"
              className="playerButtons"
              onClick={props.discardHandler}
            ><p className="playerButtonText">
                {Translate({ id: "Player.Finish" })}
              </p>
            </Button>
          )}
          {props.elapsedTime > 60 && (
            <Button
              variant="contained"
              color="secondary"
              className="playerButtons"
              onClick={props.logClassHandler}
            >
              <p className="playerButtonText">
                {Translate({ id: "Player.Finish" })}
              </p>
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
